/**
 * ArtGold Stack Builder — artgold-stack-builder.js
 * Pick up to N sizes, add all to cart in one click.
 */
(function () {
  'use strict';

  function money(cents) {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2
    }).format((cents || 0) / 100);
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }

  document.querySelectorAll('[id^="AgStack-"]').forEach(function (root) {
    var maxSlots = parseInt(root.dataset.maxSlots, 10) || 3;

    // State: array of { variantId, title, price, image } or null
    var stack = [];
    for (var i = 0; i < maxSlots; i++) stack.push(null);

    var sizeBtns = qsa('[data-ag-stack-size]', root);
    var slots = qsa('[data-ag-stack-slot]', root);
    var countEl = qs('[data-ag-stack-count]', root);
    var summaryEl = qs('[data-ag-stack-summary]', root);
    var totalEl = qs('[data-ag-stack-total]', root);
    var totalAmountEl = qs('[data-ag-stack-total-amount]', root);
    var ctaBtn = qs('[data-ag-stack-atc]', root);
    var giftNote = qs('[data-ag-stack-gift]', root);

    function getFilledCount() {
      return stack.filter(function (s) { return s !== null; }).length;
    }

    function findEmptySlot() {
      for (var i = 0; i < stack.length; i++) {
        if (stack[i] === null) return i;
      }
      return -1;
    }

    function render() {
      var count = getFilledCount();
      var total = 0;
      var names = [];

      // Update slots
      slots.forEach(function (slotEl, idx) {
        var item = stack[idx];
        var emptyEl = qs('.ag-stack__slot-empty', slotEl);
        var filledEl = qs('.ag-stack__slot-filled', slotEl);

        if (item) {
          slotEl.classList.add('is-filled');
          emptyEl.hidden = true;
          filledEl.hidden = false;
          qs('[data-ag-slot-name]', slotEl).textContent = item.title;
          qs('[data-ag-slot-price]', slotEl).textContent = money(item.price);
          var img = qs('[data-ag-slot-img]', slotEl);
          if (img && item.image) {
            img.src = item.image;
            img.alt = item.title;
          }
          total += item.price;
          names.push(item.title);
        } else {
          slotEl.classList.remove('is-filled');
          emptyEl.hidden = false;
          filledEl.hidden = true;
        }
      });

      // Update size button selected states
      sizeBtns.forEach(function (btn) {
        var vid = btn.dataset.variantId;
        var selectedCount = stack.filter(function (s) { return s && String(s.variantId) === vid; }).length;
        btn.classList.toggle('is-selected', selectedCount > 0);
      });

      // Count
      if (countEl) countEl.textContent = '(' + count + ' of ' + maxSlots + ')';

      // Summary
      if (summaryEl) {
        if (count === 0) {
          summaryEl.textContent = 'Select your first pair to begin';
        } else {
          summaryEl.textContent = 'Your stack: ' + names.join(' + ');
        }
      }

      // Total
      if (totalEl && totalAmountEl) {
        if (count > 0) {
          totalEl.hidden = false;
          totalAmountEl.textContent = money(total);
        } else {
          totalEl.hidden = true;
        }
      }

      // CTA
      if (ctaBtn) {
        ctaBtn.disabled = count === 0;
        if (count > 1) {
          ctaBtn.textContent = 'Add ' + count + ' Pairs to Bag';
        } else if (count === 1) {
          ctaBtn.textContent = 'Add to Bag';
        } else {
          ctaBtn.textContent = 'Add Stack to Bag';
        }
      }

      // Gift note for 2+
      if (giftNote) {
        giftNote.hidden = count < 2;
      }
    }

    // Size button click: add to next empty slot
    sizeBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var emptyIdx = findEmptySlot();
        if (emptyIdx === -1) return; // All slots full

        stack[emptyIdx] = {
          variantId: btn.dataset.variantId,
          title: btn.dataset.variantTitle,
          price: parseInt(btn.dataset.variantPrice, 10),
          image: btn.dataset.variantImage || ''
        };
        render();
      });
    });

    // Slot remove click
    slots.forEach(function (slotEl, idx) {
      var removeBtn = qs('[data-ag-slot-remove]', slotEl);
      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          stack[idx] = null;
          render();
        });
      }
    });

    // Add stack to cart
    if (ctaBtn) {
      ctaBtn.addEventListener('click', function () {
        var items = stack.filter(function (s) { return s !== null; });
        if (!items.length) return;

        ctaBtn.disabled = true;
        ctaBtn.textContent = 'Adding...';

        var payload = {
          items: items.map(function (item) {
            return { id: parseInt(item.variantId, 10), quantity: 1 };
          })
        };

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(payload)
        })
          .then(function (r) {
            if (!r.ok) throw new Error('Cart error');
            return r.json();
          })
          .then(function () {
            ctaBtn.textContent = 'Added to Bag ✓';
            ctaBtn.style.background = '#1f6f43';
            ctaBtn.style.borderColor = '#1f6f43';

            // Dispatch cart refresh for theme drawer
            document.dispatchEvent(new CustomEvent('cart:refresh'));

            // Try Shopify analytics
            try {
              if (window.Shopify && Shopify.analytics) {
                Shopify.analytics.publish('artgold_stack_add_to_cart', {
                  items: items.map(function (i) { return i.title; }),
                  total: items.reduce(function (sum, i) { return sum + i.price; }, 0)
                });
              }
            } catch (e) {}

            setTimeout(function () {
              ctaBtn.textContent = 'Add Stack to Bag';
              ctaBtn.style.background = '';
              ctaBtn.style.borderColor = '';
              // Clear stack
              for (var i = 0; i < stack.length; i++) stack[i] = null;
              render();
            }, 2200);
          })
          .catch(function () {
            ctaBtn.disabled = false;
            ctaBtn.textContent = 'Try Again';
            setTimeout(function () { render(); }, 1500);
          });
      });
    }

    // Initial render
    render();
  });
})();